import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { FundSummary, IndexCompany, PerformanceDashboardChart } from '../../shared/models';
import { IndexCompanyLastUpdated } from 'src/app/shared/models/company/index-company-last-updated.model';


/**
 * Data service class for performance dashboard
 */
@Injectable({
  providedIn: 'root'
})
export class PerformanceDashboardService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets the list of fund summary records
   * @param portfolioId
   * @returns {Observable<PaginatedList<FundSummary>>}
   */
  public getPortfolioIntraDaySummary (portfolioId?: number): Observable<PaginatedList<FundSummary>> {
    const id = portfolioId ? portfolioId : 1;
    return super.getData(`/api/portfolio/portfolios/${id}/intradaysummaries`);
  }

  /**
   * Gets the index companies data
   * Requires extrafield param to fetch intradaySummary and links: {extrafield: ['intradaySummary', 'link']}
   * @param {object} params
   * @returns {Observable<PaginatedList<IndexCompany>>}
   */
  public getIndexCompanies (params?: object): Observable<PaginatedList<IndexCompany>> {
    return super.getData(`/api/rms/indexcompanies`, params);
  }

  /**
   * Gets the index companies last update date
   * @returns {Observable<IndexCompanyLastUpdated>}
   */
  public getIndexCompaniesLastUpdate (): Observable<IndexCompanyLastUpdated> {
    return super.getData(`/api/rms/indexcompanies/file/holdings`);
  }

  /**
   * Gets data to fill the chart
   * @returns {Observable<{}>}
   */
  public getChartData (params?: any): Observable<Array<PerformanceDashboardChart>> {
    return super.getData(`/api/portfolio/performance/chart`, params);
  }

  /**
   * Gets portfolio data
   * @returns {Observable<{}>}
   */
  public getTotalFundValue (params?: any): Observable<PaginatedList<FundSummary>> {
    return super.getData(`/api/portfolio/portfolios/totalintradaysummaries`, params);
  }
}
